export enum PickleballGameFormat {
    WIN_BY_2 = "WIN_BY_2",
    DECIDING_POINT = "DECIDING_POINT"
}